import { Card, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { useRef, useState } from 'react';
import SelectComponent from '../../common/SelectComponent/SelectComponent';
import ButtonPrimaryLarge from '../../common/ButtonPrimary/ButtonPrimaryLarge';
import { useSelector } from 'react-redux';

const QuotationFilterPDF = ({ form }) => {
  const { t } = useTranslation();

  const { productNames, suppliers, materialTypes } = useSelector(
    state => state.quotation
  );
  const getValue = field => {
    const value = form.getFieldValue(field);
    return value ? value : '';
  };
  return (
    <Card className="bg-fills-white rounded-lg border-none">
      <div className="grid grid-cols-4 items-end justify-start gap-16">
        <p className="flex flex-col gap-8 items-start">
          <span className="text-title-small font-semibold">
            {t('quotation.provider', 'Nhà Cung Cấp')}
          </span>
          <span className="text-body-large font-normal h-40">
            {getValue('supplier')}
          </span>
        </p>

        {/* <Form.Item
          label={t('quotation.product', 'Sản Phẩm')}
          className="flex flex-col gap-2"
        >
          <SelectComponent
            placeholder={t('quotation.selectProduct', 'Chọn sản phẩm')}
            options={products}
            allowClear={true}
          />
        </Form.Item> */}

        {/* <Form.Item className="flex flex-col gap-2">
          <ButtonPrimaryLarge
            onClick={handleReset}
            className="w-full"
            title={t('quotation.reset', 'Đặt Lại')}
          />
        </Form.Item> */}
      </div>
    </Card>
  );
};

export default QuotationFilterPDF;
